import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { EventService } from "./event.service";
import { Subscription } from "rxjs";


export interface SearchTermChangedEvent {
 	searchTerm: string,
	origin: string
}

@Injectable()
export class SearchService implements OnInit, OnDestroy {
  
  private _searchTerm: string = null;

  private searchSubscription: Subscription;
      
  constructor(private eventService: EventService){
    
  }

  ngOnInit(): void {
    this.searchSubscription = this.eventService.doSearch.subscribe((term) => {
      console.log(term);
    });
  }

  ngOnDestroy(): void {
    if(this.searchSubscription) this.searchSubscription.unsubscribe();
  }


  
  public setSearchTerm(searchTerm, origin: string){
    if(searchTerm !== this._searchTerm){
      this._searchTerm = searchTerm;
      this.eventService.searchTermChanged.emit({ searchTerm: searchTerm, origin: origin });
    }
  }
  
  get searchTerm(){
    return this._searchTerm;    
  }
  

}



// WEBPACK FOOTER //
// ./src/services/search.service.ts